import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '../../services/session/sessionstorage.service';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent  {
  IsSuperAdmin: boolean = false;
  IsCountryAdmin: boolean = false;
  IsSchoolAdmin: boolean = false;
  CurrentRole: string = "";
  CurrentUser: string = "";
  constructor(private _router: Router, private sessionService: SessionStorageService, private authService: AuthService) {
    
    if (this.sessionService.getUserInfo != null) {
      let role = this.sessionService.getUserInfo.userRole;
      this.CurrentUser = this.sessionService.getUserInfo.userName;
      this.CurrentRole = role;
      if (role == 'Super Admin') {
        this.IsSuperAdmin = true;
      } else if (role == 'Country Admin') {
        this.IsCountryAdmin = true;
      } else {
        this.IsSchoolAdmin = true;
      }
    }   
  }

  ngOnInit() {    
  }

  LogOut() {
    this.authService.logout();
    //this._router.navigate(['/login']);
  }

}
